import { Loading as LoadingIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Loading';
import React from 'react';

import * as S from './styled';

export function Loading() {
  return (
    <S.CenteredLoading>
      <LoadingIcon />
    </S.CenteredLoading>
  );
}
